import React, { useEffect } from "react";
import '../css/latestWork.css';

import { useLocation } from "react-router-dom";


export default function LatestWork() {

     const location = useLocation();


  useEffect(() => {
    // Load Facebook SDK
    if (!window.FB) {
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

   useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, [location]);

  return (
    <div className="latest-work-section">
      <h2 className="latest-heading">Latest Work</h2>

      <div className="fb-container">
        <div
          className="fb-page"
          data-href="https://www.facebook.com/udaansewatrust"
          data-tabs="timeline"
        //   data-width="500"
          data-height="600"
          data-small-header="false"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="false"
        ></div>
      </div>
    </div>
  );
}